import { useIsDesktopWeb } from '@/feature/responsive-design/hooks/use-is-desktop-web';

import { useFilteredLobbyGames } from './use-casino-games';
import { useFavoriteGames } from './use-favorite-games';

export type UseCasinoCategoryGamesParams = {
    isLobby: boolean;
    category?: string;
};

export const useCasinoCategoryGames = ({ isLobby, category }: UseCasinoCategoryGamesParams) => {
    const isDesktopWeb = useIsDesktopWeb();
    const { data: favoriteGamesData, isPending: isFavoriteGamesPending } = useFavoriteGames();
    const hasFavoritesCategory = (favoriteGamesData?.items.length ?? 0) >= 1;
    const isFavoritesCategory = category === 'Favorites' && (hasFavoritesCategory || isDesktopWeb);
    const isFreeSpinsCategory = category === 'Free Spins';
    const games = useFilteredLobbyGames(isLobby || isFavoritesCategory || isFreeSpinsCategory ? 'Lobby' : category);

    return {
        ...games,
        favoriteGamesData,
        isFavoriteGamesPending,
        hasFavoritesCategory,
        isFavoritesCategory,
        isFreeSpinsCategory,
    };
};
